module.exports = __webpack_public_path__ + "static/media/5DragonLegend_EN.44def562.png";